import React from 'react';
import SettingsPage from '@/pageComponents/Settings';

const Settings = () => <SettingsPage pathname="/settings" />;

export default Settings;
